/**
 * Thin wrapper around GA4 gtag so components don't call window.gtag directly.
 * Safe to call even when GA4 is not loaded (e.g. localhost, adblocker).
 */

/**
 * Fire a GA4 custom event.
 *
 * @param {string} eventName  - GA4 event name (snake_case recommended)
 * @param {Object} params     - event parameters sent to GA4
 */
export function trackEvent(eventName, params = {}) {
  if (
    typeof window !== "undefined" &&
    typeof window.gtag === "function"
  ) {
    window.gtag("event", eventName, params);
  }
}

// ── Named helpers keep call sites readable ────────────────────────────────

export const Analytics = {
  consultationClick: (source = "unknown") =>
    trackEvent("consultation_click", { event_category: "lead", source }),

  syllabusRequest: (courseName = "") =>
    trackEvent("syllabus_request", { event_category: "lead", course_name: courseName }),

  enrollClick: (courseId, courseName, price) =>
    trackEvent("begin_checkout", {
      event_category: "ecommerce",
      course_id: courseId,
      course_name: courseName,
      value: price,
      currency: "USD",
    }),

  leadSubmitted: (source = "unknown") =>
    trackEvent("generate_lead", { event_category: "lead", source }),

  exitIntentLead: () =>
    trackEvent("exit_intent_lead", { event_category: "lead", source: "exit_intent" }),

  certVerified: () =>
    trackEvent("certificate_verified", { event_category: "trust" }),

  pageView: (pageName) =>
    trackEvent("page_view", { page_title: pageName }),
};
